/* 财务模块api */
import http from '@util/http';
import { finance } from '../req';

/* -------------------------------------资金账号管理------------------------------------*/
/**
 * 获取账号列表
 */
export async function queryFinanceBooksList(params) {
  return http.get(finance.FINANCE_BOOKS_LIST, params);
}

/**
 * 获取账号明细
 */
export async function queryFinanceBooksInfo(uuid) {
  return http.get(finance.FINANCE_BOOKS_INFO, { uuid });
}

/**
 * 添加账号
 */
export async function querySaveFinanceBooks(params) {
  return http.post(finance.FINANCE_BOOKS_SAVE, params);
}

/**
 * 编辑账号
 */
export async function queryEditFinanceBooks(params) {
  return http.post(finance.FINANCE_BOOKS_EDIT, params);
}

/**
 * 删除账号
 */
export async function queryDeleteFinanceBooks(uuid) {
  return http.get(finance.FINANCE_BOOKS_DELETE, { uuid });
}

export async function queryCheckBooksErr() {
  return http.get(finance.FINANCE_BOOKS_CHECK_ERR, {});
}

/**
 * 账号统计
 */
export async function queryFinanceBooksListStatistics(params) {
  return http.get(finance.FINANCE_BOOKS_List_STATISTICS, params);
}

/**
 * 账号统计
 */
export async function queryFinanceBooksStatistics(params) {
  return http.get(finance.FINANCE_BOOKS_STATISTICS, params);
}

/* -------------------------------------资金流水记录管理------------------------------------*/

// 流水记录列表
export async function queryBooksIncomeList(params) {
  return http.get(finance.BOOKS_INCOME_LIST, params);
}

// 流水已删除记录列表
export async function queryBooksIncomeRemoveList(params) {
  return http.get(finance.BOOKS_INCOME_REMOVE_LIST, params);
}

// 流水详情
export async function queryBooksIncomeInfo(uuid) {
  return http.get(finance.BOOKS_INCOME_INFO, { uuid });
}

// 流水记录保存
export async function querySaveBooksIncome(params) {
  return http.post(finance.BOOKS_INCOME_SAVE, params);
}

// 流水记录导入
export async function queryImportBooksIncome(params) {
  return http.post(finance.BOOKS_INCOME_IMPORT, params);
}

// 流水记录删除
export async function queryDeleteBooksIncome(params) {
  return http.get(finance.BOOKS_INCOME_DELETE, params);
}

// 流水记录删除（多条）
export async function queryDeleteBooksIncomes(params) {
  return http.get(finance.BOOKS_INCOME_DELETES, params);
}

/**
 * 非业务数据
 * @param {} params
 * @returns {}
 */
export async function queryNonBusinessIncomeList(params) {
  return http.get(finance.BOOKS_INCOME_NON_BUSINESS, params);
}

/**
 * 资金统计
 */
export async function queryFinanceIncomeStatistics(params) {
  return http.get(finance.FINANCE_INCOME_STATISTICS, params);
}

/**
 * 资金运营统计
 */
export async function queryFinanceOperationalStatistics(params) {
  return http.get(finance.FINANCE_OPERATIONAL_STATISTICS, params);
}

/**
 * 资金运营统计每年统计
 */
export async function queryFinanceOperationalStatisticsDetail(params) {
  return http.get(finance.FINANCE_OPERATIONAL_STATISTICS_DETAIL, params);
}

/**
 * 走账数据统计
 * @param {} params
 * @returns {}
 */
export async function queryFinanceBooksPayStatistics(params) {
  return http.get(finance.FINANCE_INCOME_PAY_STATISTICS, params);
}

/**
 * 有账号的公司列表
 */
export async function queryFinanceBooksOrg(params) {
  return http.get(finance.FINANCE_BOOKS_ORG, params);
}

/**
 * 有账号的公司列表(通过预算组选择)
 */
export async function queryFinanceBooksOrgList(params) {
  return http.get(finance.FINANCE_BOOKS_ORG_LIST, params);
}

/**
 * 获取预算类目列表
 */
export async function queryBudgetExpend(params) {
  return http.get(finance.FINANCE_BUDGET_EXPEND, params);
}

/**
 *
 */
export async function queryIncomeDetail(params) {
  return http.get(finance.FINANCE_INCOME_DETAIL, params);
}

export async function queryBookInfoList(params) {
  return http.get(finance.GET_BOOKINFO_LIST, params);
}

export async function queryBookInfoInfo(params) {
  return http.get(finance.GET_BOOKINFO_INFO, params);
}

export async function querySaveBookInfo(params) {
  return http.post(finance.SAVE_BOOKINFO, params);
}

export async function queryDeleteBookInfo(params) {
  return http.get(finance.DELETE_BOOKINFO, params);
}

export async function queryAbleBookInfo(params) {
  return http.post(finance.ABLE_BOOKINFO, params);
}



// WEBPACK FOOTER //
// ./src/api/finance/finance.js